// extracted by mini-css-extract-plugin
module.exports = {"img":"ComingSoon_img__cjhxa","title":"ComingSoon_title__3_Vkx","desc":"ComingSoon_desc__3Vzd4","button":"ComingSoon_button__GDY4k"};